import React from "react";
import { useTranslation } from "react-i18next";
import { Fade } from "react-awesome-reveal";

import SectionTitle from "../home/SectionTitle";

import movesTop from "../../img/accounts/moves-top.webp";
import movesCenter from "../../img/accounts/moves-center.webp";
import movesBottom from "../../img/accounts/moves-bottom.webp";

const ITEMS = [
  { leadKey: "accountsPage.moves.item1.lead", textKey: "accountsPage.moves.item1.text" },
  { leadKey: "accountsPage.moves.item2.lead", textKey: "accountsPage.moves.item2.text" },
  { leadKey: "accountsPage.moves.item3.lead", textKey: "accountsPage.moves.item3.text" },
  { leadKey: "accountsPage.moves.item4.lead", textKey: "accountsPage.moves.item4.text" },
  { leadKey: "accountsPage.moves.item5.lead", textKey: "accountsPage.moves.item5.text" },
];

function ThreeMoves() {
  const { t } = useTranslation();

  return (
    <section className="mt">
      <div className="glcontainer">
        <div className="flex flex-col lg:flex-row gap-[25px] lg:gap-[56px] items-start">
          {/* Коллаж (только desktop) */}
          <Fade triggerOnce direction="left" duration={700} className="hidden lg:block w-[51.3%] shrink-0">
          <div className="relative w-full aspect-[626/492]">
            {/* Верх слева */}
            <div className="absolute left-0 top-0 w-[45.7%] h-[57.3%] rounded-[20px] overflow-hidden">
              <img src={movesTop} alt="" aria-hidden className="w-full h-full object-cover" />
            </div>

            {/* Высокая по центру */}
            <div className="absolute left-[49.7%] top-[8.9%] w-[50.3%] h-[78.9%] rounded-[20px] overflow-hidden">
              <img src={movesCenter} alt="" aria-hidden className="w-full h-full object-cover" />
            </div>

            {/* Низ слева */}
            <div className="absolute left-0 top-[62%] w-[45.7%] h-[38%] rounded-[20px] overflow-hidden">
              <img src={movesBottom} alt="" aria-hidden className="w-full h-full object-cover" />
            </div>
          </div>
          </Fade>

          {/* Контент справа */}
          <div className="flex flex-col flex-1 w-full lg:pt-[44px]">
            <SectionTitle
              title1={t("accountsPage.moves.title1")}
              title2={t("accountsPage.moves.title2")}
              text={t("accountsPage.moves.subtitle")}
              align="left"
              className="max-w-[525px] [&>p]:max-w-none"
            />

            <ul className="mt-[15px] flex flex-col gap-[15px] max-w-[525px]">
              <Fade cascade triggerOnce direction="up" damping={0.06}>
                {ITEMS.map((item) => (
                  <li
                    key={item.leadKey}
                    className="font-['Inter'] font-normal text-[16px] leading-[1.5] text-[#435c7f] list-disc ml-[24px]"
                  >
                    <span className="font-bold">{t(item.leadKey)}</span>
                    {" - "}
                    {t(item.textKey)}
                  </li>
                ))}
              </Fade>
            </ul>
          </div>
        </div>
      </div>
    </section>
  );
}

export default ThreeMoves;
